export default class TravelServiceOrderItemInsurance {
  place_id = null;
  start_date = null;
  end_date = null;
}
